import axios, { AxiosInstance } from 'axios';

import { getStaticConfig } from ':support/config';
import { setRedirectUri } from ':support/utils/session-utils/redirectUriStorage';

// Keep a singleton instance of the API client
let APIClient: AxiosInstance | null = null;

export function initAPIClient() {
  if (!APIClient) {
    const { logoutURL } = getStaticConfig();
    const instance = axios.create({
      baseURL: '/service-api',
      responseType: 'json',
      headers: { 'Content-Type': 'application/json' },
    });

    // Attach the interceptor
    instance.interceptors.response.use(
      (response) => response,
      async (error) => {
        // Check if the error is a 401 Unauthorized
        if (error.response?.status === 401) {
          // Store current path for redirect after login
          if (typeof window !== 'undefined' && window.location.pathname !== '/') {
            setRedirectUri(window.location.pathname + window.location.search);
          }

          // Redirect if not in local development
          if (typeof window !== 'undefined') {
            window.location.assign(logoutURL);
          }
        }

        return Promise.reject(error);
      },
    );

    APIClient = instance;
  }

  return APIClient;
}

export function getAPIClient() {
  if (!APIClient) {
    throw new Error('APIClient not initialized. Call initAPIClient first.');
  }
  return APIClient;
}
